module.exports = __webpack_public_path__ + "img/link.2a01ce0c.svg";